<i18n locale="en">
{
  "labels": {
    "carousel-assets": "Carousel photos",
    "headline": "Title"
  },
  "placeholders": {
    "headline": "Aa"
  }
}
</i18n>

<template>
  <div class="flex-col gap-8">
    <OwnInputContainer
      :label="t('labels.headline')"
      :errors="headline.status.errors"
      :max-chars="websiteSectionMaxChars(MAX_HEADLINE_LENGTH)"
      :value="headline.value"
    >
      <OwnTextarea
        v-model="headline.value"
        :placeholder="t('placeholders.headline')"
        rows="4"
      />
    </OwnInputContainer>
    <OwnInputContainer :label="t('labels.carousel-assets')">
      <HeroCarouselEditor :id="id" />
    </OwnInputContainer>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import { mapGetters } from 'vuex'

import {
  websiteSectionMaxChars,
  WebsiteSectionValidators,
} from '@/features/website-builder/builder/validation/websiteSectionValidators'
import { FormBuilder } from '@/forms'
import { OwnInputContainer } from '@/ui/OwnInputContainer'
import { OwnTextarea } from '@/ui/OwnTextarea'

import { LandingHeroCommands } from '../commands/LandingHeroCommands'

import HeroCarouselEditor from './HeroCarouselEditor'

const MAX_HEADLINE_LENGTH = 150

export default {
  name: 'LandingHeroEditor',
  components: {
    HeroCarouselEditor,
    OwnInputContainer,
    OwnTextarea,
  },
  mixins: [
    FormBuilder({
      headline: {
        debounce: 250,
        validateOnInit: true,
        validators: [
          WebsiteSectionValidators.required,
          WebsiteSectionValidators.maxLength(MAX_HEADLINE_LENGTH),
        ],
      },
    }),
  ],
  props: {
    /**
     * Id getting passed to the editor component
     */
    id: { type: String, required: true },
  },
  setup() {
    const { t } = useI18n()

    return { t, websiteSectionMaxChars }
  },
  data() {
    return {
      MAX_HEADLINE_LENGTH,
    }
  },
  computed: {
    ...mapGetters({
      blockById: 'websiteBuilder/blockById',
      originalBlockById: 'websiteBuilder/originalBlockById',
    }),
    currentBlockParams() {
      const { id } = this

      return this.blockById(id)?.params
    },
    publishedBlockParams() {
      const { id } = this

      return this.originalBlockById(id)?.params
    },
  },
  async created() {
    const { currentBlockParams, publishedBlockParams } = this

    this.setInitialFormValues({ headline: currentBlockParams.headline })

    // Auto-migrate to layout 2 (cover) if not already published with it
    if (publishedBlockParams?.layout !== 'cover') {
      await this.applyLandingHeroUpdate({ layout: 'cover' })
    }
  },
  methods: {
    async applyLandingHeroUpdate(newValue) {
      const { id } = this

      await LandingHeroCommands.updateBlock({
        targetId: id,
        update: {
          params: {
            ...newValue,
          },
        },
      })
    },
    async onFormControlUpdate(controlName, value) {
      if (!this.isFormValid) return

      await this.applyLandingHeroUpdate({ [controlName]: value })
    },
  },
}
</script>
